// Values mirrored from backend: libs/shared/src/models/Action.ts
// (ActionStatusEnum, ActionCodeEnum, ActionTypeEnum)

export enum ActionStatusEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum ActionCodeEnum {
  ACCOUNT_VIEW = "ACCOUNT_VIEW",
  ACTIONS_VIEW = "ACTIONS_VIEW",
  CALENDAR_APP_DETAIL_VIEW = "CALENDAR_APP_DETAIL_VIEW",
  CALENDAR_HOME_UPCOMING_APP_VIEW = "CALENDAR_HOME_UPCOMING_APP_VIEW",
  CALENDAR_VIEW = "CALENDAR_VIEW",
  CATEGORIES_VIEW = "CATEGORIES_VIEW",
  CHAT_CONTACTS_VIEW = "CHAT_CONTACTS_VIEW",
  CHAT_MESSAGES_VIEW = "CHAT_MESSAGES_VIEW",
  COLOR_ADD = "COLOR_ADD",
  COLOR_AUDIT_LOG = "COLOR_AUDIT_LOG",
  COLOR_BATCH_UPLOAD = "COLOR_BATCH_UPLOAD",
  COLOR_DELETE = "COLOR_DELETE",
  COLOR_EDIT = "COLOR_EDIT",
  COLOR_LIST_VIEW = "COLOR_LIST_VIEW",
  DASHBOARD_VIEW = "DASHBOARD_VIEW",
  EXPORT_CA_SHORT_QUESTIONNAIRE = "EXPORT_CA_SHORT_QUESTIONNAIRE",
  EXPORT_DATA_VIEW = "EXPORT_DATA_VIEW",
  EXTERNAL_PROVIDERS_VIEW = "EXTERNAL_PROVIDERS_VIEW",
  EXTERNAL_PROVIDER_VIEW = "EXTERNAL_PROVIDER_VIEW",
  GOAL_TEMPLATES_VIEW = "GOAL_TEMPLATES_VIEW",
  HELP_SUPPORT_VIEW = "HELP_SUPPORT_VIEW",
  HOME_APPROVAL_REQUESTS = "HOME_APPROVAL_REQUESTS",
  HOME_PROGRESS_UPDATES = "HOME_PROGRESS_UPDATES",
  HOME_UPCOMING_APPOINTMENTS = "HOME_UPCOMING_APPOINTMENTS",
  IN_HOUSE_SERVICES_VIEW = "IN-HOUSE_SERVICES_VIEW",
  INFORMATION_RESOURCES_VIEW = "INFORMATION_RESOURCES_VIEW",
  MANAGEMENT_OPTIONS_VIEW = "MANAGEMENT_OPTIONS_VIEW",
  ORGANIZATIONS_VIEW = "ORGANIZATIONS_VIEW",
  ORGANIZATION_LABELS_VIEW = "ORGANIZATION_LABELS_VIEW",
  ORG_UNITS_VIEW = "ORG_UNITS_VIEW",
  PARTICIPANTS_AUDIT_LOG = "PARTICIPANTS_AUDIT_LOG",
  PARTICIPANTS_VIEW = "PARTICIPANTS_VIEW",
  PARTICIPANT_ADD = "PARTICIPANT_ADD",
  PARTICIPANT_ADD_BATCH_UPLOAD = "PARTICIPANT_ADD_BATCH_UPLOAD",
  PARTICIPANT_ADD_GROUP_APPT = "PARTICIPANT_ADD_GROUP_APPT",
  PARTICIPANT_ADD_INDV_APPT = "PARTICIPANT_ADD_INDV_APPT",
  PARTICIPANT_APPOINTMENTS_VIEW = "PARTICIPANT_APPOINTMENTS_VIEW",
  PARTICIPANT_APPT_VIEW = "PARTICIPANT_APPT_VIEW",
  PARTICIPANT_AUDIT_LOG = "PARTICIPANT_AUDIT_LOG",
  PARTICIPANT_DELETE_APPOINTMENT = "PARTICIPANT_DELETE_APPOINTMENT",
  PARTICIPANT_DISMISS_CLIENT = "PARTICIPANT_DISMISS_CLIENT",
  PARTICIPANT_EDIT = "PARTICIPANT_EDIT",
  PARTICIPANT_EDIT_APPOINTMENT = "PARTICIPANT_EDIT_APPOINTMENT",
  PARTICIPANT_GOALS_VIEW = "PARTICIPANT_GOALS_VIEW",
  PARTICIPANT_JOURNALS_VIEW = "PARTICIPANT_JOURNALS_VIEW",
  PARTICIPANT_LOG_ACTIVITY = "PARTICIPANT_LOG_ACTIVITY",
  PARTICIPANT_MANAGE_CASE_PLAN = "PARTICIPANT_MANAGE_CASE_PLAN",
  PARTICIPANT_MANAGE_INT_PROVIDERS = "PARTICIPANT_MANAGE_INT_PROVIDERS",
  PARTICIPANT_MANAGE_OFFICERS = "PARTICIPANT_MANAGE_OFFICERS",
  PARTICIPANT_MANAGE_SUPPORT_STAFF = "PARTICIPANT_MANAGE_SUPPORT_STAFF",
  PARTICIPANT_MARK_AS_ABSENCE = "PARTICIPANT_MARK_AS_ABSENCE",
  PARTICIPANT_PROFILE_VIEW = "PARTICIPANT_PROFILE_VIEW",
  PARTICIPANT_REVERT_ABSENCE = "PARTICIPANT_REVERT_ABSENCE",
  PARTICIPANT_REWARDS_VIEW = "PARTICIPANT_REWARDS_VIEW",
  PARTICIPANT_REWARD_APPROVE = "PARTICIPANT_REWARD_APPROVE",
  PARTICIPANT_REWARD_MANUAL_ENTER = "PARTICIPANT_REWARD_MANUAL_ENTER",
  PARTICIPANT_REWARD_MANUAL_SUBMIT = "PARTICIPANT_REWARD_MANUAL_SUBMIT",
  PARTICIPANT_REWARD_REJECT = "PARTICIPANT_REWARD_REJECT",
  PARTICIPANT_WALKIN_INHOUSE_SERV_DETAIL = "PARTICIPANT_WALKIN_INHOUSE_SERV_DETAIL",
  PARTICIPANT_WALKIN_LOG_INHOUSE_SERV = "PARTICIPANT_WALKIN_LOG_INHOUSE_SERV",
  PROGRAMS_VIEW = "PROGRAMS_VIEW",
  REPORT_VIEW = "REPORT_VIEW",
  RESOURCE_VIEW = "RESOURCE_VIEW",
  REWARDS_CONFIGURATION_VIEW = "REWARDS_CONFIGURATION_VIEW",
  ROLES_VIEW = "ROLES_VIEW",
  SETTINGS_VIEW = "SETTINGS_VIEW",
  TREATMENT_AGENCIES_VIEW = "TREATMENT_AGENCIES_VIEW",
  USERS_AUDIT_LOG_VIEW = "USERS_AUDIT_LOG_VIEW",
  USERS_VIEW = "USERS_VIEW",
  USER_ADD = "USER_ADD",
  USER_ADD_BATCH_UPLOAD = "USER_ADD_BATCH_UPLOAD",
  USER_DELETE = "USER_DELETE",
  USER_EDIT = "USER_EDIT",
  USER_RESEND_INVITATION = "USER_RESEND_INVITATION",
}

export enum ActionTypeEnum {
  MENU_OPTION = "MENU_OPTION",
  OPTION = "OPTION",
}

export const ACTION_STATUS_OPTIONS = [
  { key: ActionStatusEnum.ACTIVE, value: "Active" },
  { key: ActionStatusEnum.INACTIVE, value: "Inactive" },
];

export const ACTION_TYPE_OPTIONS = [
  { key: ActionTypeEnum.MENU_OPTION, value: "Menu option" },
  { key: ActionTypeEnum.OPTION, value: "Option" },
];

export const ACTION_CODE_OPTIONS = Object.values(ActionCodeEnum).map(
  (code) => ({ key: code, value: code })
);
